import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getParty = (state) => {
 
  return axios.get(API + "parties/party-edit/"+state+"/",{headers: authHeader(),});
};
const editParty = (state, party_type,customer_type, customer_name,establishment_date, TIN_number,sales_tax_code,website,prefix,first_name,middle_name,last_name,ssn_tin_number,id_number,id_issue_state,date_of_birth,arr,consolidate_invoice,pre_bill_days,generate_invoice,
   doingBusinessAs,
  business_type,
  federalID,
  SIC,
  NAICS,
  riskrating,
  creditscore,
  ACHPayments
) => {
    return axios.post(API + "parties/party-edit/" +state+"/", {
        party_type,
        customer_type,
        customer_name,
        establishment_date,
        TIN_number,
        sales_tax_code,
        website,
        prefix,
        first_name,
        middle_name,
        last_name,
        ssn_tin_number,
        id_number,
        id_issue_state,
        date_of_birth,
        arr,
        consolidate_invoice,
        pre_bill_days,
        generate_invoice,
        doingBusinessAs,
        business_type,
        federalID,
        SIC,
        NAICS,
        riskrating,
        creditscore,
        ACHPayments
    },{headers: authHeader(),});
  };
const EditPartyService = {
    getParty,
    editParty,
  };
  export default EditPartyService;